module.exports = __webpack_public_path__ + "img/cooperate_15.5f39aaf2.png";